import { HUD_STATS_PROP_LBL_CLR_MAP } from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import StatProgressBar from "@/src/components/CommonCharts/StatProgressBar";

export const StealCheckRaiseSection = ({
  hudStats,
  hudStatsProgressBarArr,
}) => {
  if (!hudStats || Object.keys(hudStats).length === 0) return null;
  return (
    <div className="steal-check-raise grid grid-cols-2 gap-3 mt-3">
      {hudStatsProgressBarArr.map((item) =>
        hudStats.hasOwnProperty(item) && !isNaN(Number(hudStats[item])) ? (
          <div
            key={item}
            className={`flex flex-col ${styles.coreCardConfigBkNoBorder} py-4.25 px-3 gap-1.25`}
          >
            <StatProgressBar
              labelLeft={HUD_STATS_PROP_LBL_CLR_MAP[item].label}
              value={hudStats[item]}
            />
          </div>
        ) : null
      )}
    </div>
  );
};
